import RequestApi from "../../modules/requestApi";

const state = {
  // данные по авторизованному пользователю
  user: null,
  // признак, что авторизация пройдена
  loggedIn: false
};

const mutations = {
  // смена данных пользователя
  SET_USER(state, user) {
    state.user = user;
  },
  // смена признака авторизации
  SET_LOGGED_IN(state, value) {
    state.loggedIn = value;
  }
};

const actions = {
  // авторизация пользователя
  login: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      RequestApi.userLogin(data)
        .then(result => {
          commit("SET_USER", result.user);
          commit("SET_LOGGED_IN", true);
          resolve();
        })
        .catch(error => {
          commit("SET_LOGGED_IN", false);
          reject(error);
        });
    });
  },

  // загрузка данных авторизованного пользователя
  userLoad({ commit }) {
    return new Promise((resolve, reject) => {
      RequestApi.userLoad()
        .then(user => {
          commit("SET_USER", user);
          resolve(user);
        })
        .catch(error => {
          commit("SET_LOGGED_IN", false);
          reject(error);
        });
    });
  },

  // Выход из ЛК
  logout: ({ dispatch }) => {
    RequestApi.userLogout().then(() => {
      // todo сделать чистку парасметров user
      dispatch("clearUserData");
    });
  },

  //очистка основной и-ии стор
  clearUserData({ commit }) {
    commit("SET_USER", {});
    commit("SET_LOGGED_IN", false);
    commit("SET_HOTSPOT_LIST", []);
    commit("SET_HOTSPOT_IS_LOADED", false);
    commit("SET_THEME_LIST", []);
    commit("SET_THEME_IS_LOADED", false);
    commit("SET_ADV_LIST", []);
    commit("SET_ADV_IS_LOADED", false);
    commit("SET_POLL_LIST", []);
    commit("SET_POLL_IS_LOADED", false);
  }
};

const getters = {
  // признак, что авторизация пройдена
  loggedIn: state => {
    return state.loggedIn;
  },
  // данные по авторизованному пользователю
  user: state => {
    return state.user;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
